import React from 'react'
import { SWRConfig } from 'swr'

const SwrConfig = function ({ children, value = {}, http }) {
  const finalValue = {
    fetcher: (url) => {
      http().get(url).json()
    },
    revalidateOnFocus: false,
    dedupingInterval: 30000,
    onError: (error) => {
      if (error.status === 401) {
        // window.location.href = `${dygcDomain}/login?url=${window.location.href}`
      }
    },
    ...value,
  }
  return <SWRConfig value={finalValue}>{children}</SWRConfig>
}

export default SwrConfig
